import { useAsyncFeedbackStore } from "@/shared/feedback/asyncFeedbackStore";

/**
 * Toasts do app (um só sistema: o mesmo do useAsyncAction / AsyncFeedbackProvider).
 *   toast.success("Usuário criado.")
 *   toast.error(getApiErrorMessage(err))
 * Para operações assíncronas prefira `useAsyncAction().run(fn, { loading, success, error })`.
 */
export const toast = {
  success: (message: string) => useAsyncFeedbackStore.getState().pushToast("success", message),
  error: (message: string) => useAsyncFeedbackStore.getState().pushToast("error", message),
  info: (message: string) => useAsyncFeedbackStore.getState().pushToast("info", message),
  warning: (message: string) => useAsyncFeedbackStore.getState().pushToast("warning", message),
};
